import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { User } from '../../providers/user/user';
import { GlobalNotificationsProvider } from '../../providers/providers';

/**
 * Generated class for the MessengerPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
  defaultHistory: ["HomePage"]
})
@Component({
  selector: 'page-messenger',
  templateUrl: 'messenger.html',
})
export class MessengerPage {
  messenger: string;
  search: string = '';
  picksCount: number;
  refresh: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private userService: User,
    private globalNotificationsProvider: GlobalNotificationsProvider
  ) {
    const params = navParams.get('events');
    this.messenger = params ? params : 'messages';
  }

  ionViewDidLoad() {
    // this.loadPicksCount();

    // this.globalNotificationsProvider.picksRemainingCount.subscribe(
    //   count => (this.picksCount = count)
    // );
  }

  onInput(event: any): void {}

  onCancel(event): void {
    this.search = '';
  }

  switchSegment(event) {
    if (event) {
      this.messenger = event;
    }
  }

  async loadPicksCount() {
    const user = await this.userService.currentUser();
    this.globalNotificationsProvider
      .getRemainingPicks(user.uuid)
      .subscribe(res => {
        this.globalNotificationsProvider.setPicksRemainingCount(res.count);
      });
  }
  doRefresh(refresher) {
    setTimeout(() => {
      this.refresh = !this.refresh;
      refresher.complete();
    }, 0);
  }
}



// WEBPACK FOOTER //
// ./src/pages/messenger/messenger.ts